import { ApiHandler } from '@eshop/api-client'

import type { Filter } from '#/global/component/Product/ProductFilters'

export const fetchEshopFilters = async (productCodes: string[], selectedFilters: Record<string, string[] | number[]>) => {
    const body = {
        productCodes,
        availabilityIds: selectedFilters.AVAILABILITY?.map(value => +value),
        brandIds: selectedFilters.BRAND?.map(value => +value),
        minPrice: selectedFilters.PRICE?.[0],
        maxPrice: selectedFilters.PRICE?.[1],
    }
    return fetchFilters(body, 'eshop')
}

export const fetchRentalFilters = async (productCodes: string[], selectedFilters: Record<string, string[] | number[]>) => {
    const body = {
        groupCodes: productCodes,
        minPrice: selectedFilters.PRICE?.[0],
        maxPrice: selectedFilters.PRICE?.[1],
    }
    return fetchFilters(body, 'rental')
}

const fetchFilters = async (body: Record<string, string[] | number[] | number | string>, url: 'rental' | 'eshop') => {
    const api = new ApiHandler({
        path: '/product/get-search-filters-{url}',
        method: 'POST',
        pathParameters: {
            url,
        },
        body: JSON.stringify(body),
    })
    return await api.send<Filter[]>() ?? []
}
